// Recruiting — its own page in the top menu, between Payroll and LINKS
// (owner, 2026-09-25: "move recruiting out of People as its own top line").
// docs/RECRUITING-PLAN.md. Owner preview (lib/ownerPreview.ts, ruling
// 2026-09-24): the real board for Tomer signed in as himself; "Coming soon"
// for everyone else until he opens it to the managers.
import type { JSX } from 'preact';
import { useState } from 'preact/hooks';
import { RecruitingBoard } from '../components/recruiting/RecruitingBoard';
import { RecruitingNumbers } from '../components/recruiting/RecruitingNumbers';
import { recruitingPreview } from '../lib/ownerPreview';

export function RecruitingPage(): JSX.Element {
  const [tab, setTab] = useState<'BOARD' | 'NUMBERS'>('BOARD');
  return (
    <div class="main">
      <div class="page-header">
        <h1>nvRecruiter</h1>
      </div>
      {recruitingPreview() ? (
        <div class="actions" data-testid="recruiting-page-tabs">
          <button type="button" class="btn" aria-pressed={tab === 'BOARD'} onClick={() => setTab('BOARD')} data-testid="recruiting-tab-board">Board</button>
          <button type="button" class="btn" aria-pressed={tab === 'NUMBERS'} onClick={() => setTab('NUMBERS')} data-testid="recruiting-tab-numbers">Numbers</button>
        </div>
      ) : null}
      {recruitingPreview() ? (tab === 'NUMBERS' ? <RecruitingNumbers /> : <RecruitingBoard />) : (
        <div class="card" data-testid="recruiting-coming-soon">
          <div class="section-head">
            <h2>nvRecruiter</h2>
          </div>
          <div class="table-wrap">
            <table class="roster-table">
              <thead>
                <tr>
                  <th>nvRecruiter</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Coming soon</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
